export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));

    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    }

    console.log('[PWA] Cleared existing service workers and browser caches.');
  } catch (error) {
    console.error('[PWA] Failed to clear service workers and browser caches:', error);
  }
}
